import { useAppSelector } from '../useAppSelector';

export default function useStoreIntegrationName(storeSlug: string) {
	return useAppSelector(state => state.get('appData').get('storeIntegrations').get(storeSlug)?.get('name') ?? storeSlug)
}
